// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document);
      });
    }
  });
};

async function checkProductStock(productHandle, variantId = null) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    const product = await response.json();
    if (variantId) {
      const variant = product.variants.find((v) => v.id === variantId);
      if (variant) {
        return variant.available;
      }
    }
    return product.available;
  } catch (error) {
    console.error(`Error checking product stock: ${error}`);
    return true;
  }
}

async function convertCurrency(amount) {
  // Use the actual exchange rate without rounding for precision
  var rate = Shopify.currency.rate;
  var originalAmount = amount;

  console.log('=== Currency Conversion ===');
  console.log('Active Currency:', Shopify.currency.active);
  console.log('Exchange Rate:', rate);
  console.log('Original Amount (USD):', originalAmount);

  // Convert from USD base price to active currency
  if (Shopify.currency.active !== 'USD') {
    amount *= rate;
    console.log('Converted Amount:', amount);
  } else {
    console.log('No conversion needed (USD)');
  }

  // Format in the active currency
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active
  }).format(amount);

  console.log('Formatted Amount:', formattedAmount);

  // Extract just the number part (remove currency symbol)
  const numericValue = formattedAmount.replace(/[^\d.,]/g, '').trim();
  console.log('Final Numeric Value:', numericValue);
  console.log('===========================');

  return numericValue;
}

async function returnCurrencyName() {
  // Return empty for USD (we'll show "USD" suffix separately)
  if (Shopify.currency.active === 'USD') {
    return '';
  }

  // Special case for Aruban Florin which uses "Afl" symbol
  if (Shopify.currency.active === 'AWG') {
    return 'Afl ';
  }

  // For other currencies, return the currency code with a space
  return Shopify.currency.active + ' ';
}


document.ready().then(async function () {
  const giftBoxID = 30331558527060;
  const checkboxValue = "giftbox";
  const CACHE_KEY = 'giftBoxProductData';
  const CACHE_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

  // Fetch gift box product data from Shopify or sessionStorage cache
  let giftBoxProduct = null;
  let giftBoxPrice = 4; // fallback price

  console.log('=== Gift Box Product Fetch ===');
  console.log('Looking for Gift Box Variant ID:', giftBoxID);

  try {
    // Check sessionStorage cache first
    const cachedData = sessionStorage.getItem(CACHE_KEY);
    let shouldFetch = true;

    if (cachedData) {
      const { product, timestamp } = JSON.parse(cachedData);
      const now = Date.now();

      // Check if cache is still valid (less than 1 hour old)
      if (now - timestamp < CACHE_DURATION) {
        console.log('Using cached product data');
        giftBoxProduct = product;
        const variant = product.variants.find(v => v.id === giftBoxID) || product.variants[0];
        console.log('Found variant:', variant);
        console.log('Variant price (cents):', variant.price);
        giftBoxPrice = variant.price / 100;
        console.log('Gift box price (USD):', giftBoxPrice);
        shouldFetch = false;
      }
    }

    // Fetch from API if no valid cache
    if (shouldFetch) {
      console.log('Fetching fresh product data from /products/gift-wrapping-2.js');
      const response = await fetch('/products/gift-wrapping-2.js');
      const product = await response.json();

      console.log('Product response:', product);

      if (product && product.variants) {
        giftBoxProduct = product;
        console.log('All variants:', product.variants);

        // Find the specific variant by ID or use the first one
        const variant = product.variants.find(v => v.id === giftBoxID) || product.variants[0];
        console.log('Selected variant:', variant);
        console.log('Variant price (cents):', variant.price);

        // Get the price number from the variant (Shopify returns price in cents)
        giftBoxPrice = variant.price / 100;
        console.log('Gift box price (USD):', giftBoxPrice);

        // Store in sessionStorage with timestamp
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({
          product: product,
          timestamp: Date.now()
        }));
      }
    }
  } catch (error) {
    console.error('Error fetching gift box product data:', error);
    console.log('Using fallback price:', giftBoxPrice);
    // Continue with fallback price
  }

  console.log('=== Final Gift Box Price (already in ' + Shopify.currency.active + '): ' + giftBoxPrice + ' ===');

  // Shopify already returns the price in the active currency, so we don't need to convert
  // Just format it nicely
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(giftBoxPrice);

  // Extract just the numeric part
  const $amount = formattedAmount.replace(/[^\d.,]/g, '').trim();

  // Get currency name/symbol
  const $currencyName = await returnCurrencyName();

  // Format the display value with currency code
  const $show_value = $currencyName + $amount + (Shopify.currency.active === 'USD' ? ' USD' : '');

  console.log('=== Gift Box Display Value ===');
  console.log('Currency Name:', $currencyName);
  console.log('Amount:', $amount);
  console.log('Final Display Value:', $show_value);
  console.log('==============================');

  // Watch for the sliding cart currency changes
  watchAwaitSelector(elements => {
    // Includes the gift box elements
    const allCartProducts = document.querySelectorAll('.hs-item-cart-content');

    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

    }).then(function (response) {
      return response.json();
    }).then(function (cart) {

      // Change currency values to be quantity * price
      setTimeout(() => {
        for (let i = 0; i < allCartProducts.length; i++) {
          let $product = allCartProducts[i];
          let product = cart.items[i];

          let $productTotal = $product.querySelector('.hs-price-total .money');
          if (product && $productTotal) {

            let currency = $productTotal.getAttribute('doubly-currency');

            if (currency) {
              let symbol = $productTotal.textContent.charAt(0);
              let currencyLowercase = currency.toLowerCase();
              let amount = $productTotal.getAttribute(`doubly-currency-${currencyLowercase}`);
              let ratio = Number(amount) / product.final_price;

              let cost = product.final_line_price * ratio / 100;

              $productTotal.textContent = `${symbol}${cost.toFixed(2)} ${currency}`;

            }
            // Defaulted to USD
            else {
              let number = product.final_line_price / 100;
              $productTotal.textContent = `$${number.toFixed(2)} USD`;
            }

          }
        }
      }, 500);
    });
  }, '.hs-item-cart-content [doubly-currency]');

  watchAwaitSelector(elements => {

    // Excludes the gift box elements
    const cartProducts = document.querySelectorAll(`.hs-item-cart-content:not(.hs-product-${giftBoxID}`);

    // Includes the gift box elements
    const allCartProducts = document.querySelectorAll('.hs-item-cart-content');

    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

    }).then(function (response) {

      return response.json();
    }).then(async function (cart) {

      // Add line number of item for future update/removal
      for (let i = 0; i < cart.items.length; i++) {
        cart.items[i].line_number = i + 1;
      }

      console.log("cart is", cart);


      // For each of the product elements in the cart drawer
      for (const $product of cartProducts) {

        const $productLink = $product.querySelector('a.hs-product-title');
        const productTitle = $productLink.textContent.trim();

        const productProperties = $product.querySelectorAll('.hs-propertie');
        for (const $productProperty of productProperties) {
          if ($productProperty.textContent.includes('For:') || $productProperty.textContent.includes('Gift Message:')) {
            $productProperty.closest('.hs-content-propertie').style.display = "none";
          }
        }

        // Get product URL
        const productURL = new URL($productLink.href);
        const urlParams = new URLSearchParams(productURL.search);
        const variantID = Number(urlParams.get('variant'));


        const product = cart.items.filter(function (obj) {
          if (obj?.variant_id) {
            return obj.variant_id === variantID;
          }
        })[0];

        if (product) {
          const inStock = await checkProductStock(product.handle, product.variant_id);
          if (!inStock) {
            // skip to next product
            continue;
          }

          // If the product is not compatible with gift boxes, skip it
          if (window.excludeGiftBoxSKUs.includes(product.sku)) {
            continue;
          }
        }

        // Find the matching gift box object (if any) for this product
        var matchingGiftBox = cart.items.filter(function (obj) {
          if (obj.properties && obj.properties.For) {
            return obj.properties.For === productTitle;
          }
        })[0];

        var content;

        let $matchingGiftBox = null;

        // // This product does not have a gift box created for it
        if (matchingGiftBox === undefined) {
          content = `
          <div class="giftboxInputsWrapper">

            <div class="giftboxInputWrapper giftboxInputWrapper--checkbox">
              <input class="giftboxInputWrapper__checkbox" type="checkbox" value="${checkboxValue}">
              <label>Add a gift box and message - ${$show_value} </label>
            </div>


            <div class="giftboxInputWrapper giftboxInputWrapper--message" style="width: 100%;">
              <textarea class="giftboxInputWrapper__textarea" placeholder="Enter message here. One shipping address per order." data-new="true"></textarea>
              <span><button class="giftboxInputWrapper__saveMessage giftboxInputWrapper__button" type="button">SAVE MESSAGE</button></span>
            </div>

            <div class="giftboxInputWrapper giftboxInputWrapper--remove" style="display: none;">
              <span>Gift box</span><span>${$show_value}</span><span><button class="giftboxInputWrapper__removeButton" type="button">REMOVE</button></span>
            </div>

          </div>
        `;
          if ($product) {
            $product.insertAdjacentHTML('beforeend', content);
          }

          const $quantityDecrease = $product.querySelector('.hs-cart-plus-minus .hs-dec');
          const $quantityInput = $product.querySelector('.hs-cart-plus-minus input');
          const $quantityIncrease = $product.querySelector('.hs-cart-plus-minus .hs-inc');

          if ($quantityDecrease) {
            $quantityDecrease.addEventListener('click', event => {
              setTimeout(() => {
                if (typeof HsCartDrawer !== 'undefined') {
                  HsCartDrawer.getSlideCart();
                }
              }, 500);
            });
          }

          if ($quantityIncrease) {
            $quantityIncrease.addEventListener('click', event => {
              setTimeout(() => {
                if (typeof HsCartDrawer !== 'undefined') {
                  HsCartDrawer.getSlideCart();
                }
              }, 500);
            });
          }

          if ($quantityInput) {
            $quantityInput.addEventListener('change', event => {
              setTimeout(() => {
                if (typeof HsCartDrawer !== 'undefined') {
                  HsCartDrawer.getSlideCart();
                }
              }, 500);
            });
          }

        }
        // This product already has a gift box created for it
        else {
          $matchingGiftBox = allCartProducts[matchingGiftBox.line_number - 1]
          if ($matchingGiftBox) {
            if (product?.quantity > 1 || matchingGiftBox.quantity > 1) {
              $matchingGiftBox.classList.add('show-giftbox-quantity');

            }


            const $giftBoxQuantityDecrease = $matchingGiftBox.querySelector('.hs-cart-plus-minus .hs-dec');
            const $giftBoxQuantityInput = $matchingGiftBox.querySelector('.hs-cart-plus-minus input');
            const $giftBoxQuantityIncrease = $matchingGiftBox.querySelector('.hs-cart-plus-minus .hs-inc');

            if ($giftBoxQuantityDecrease) {
              $giftBoxQuantityDecrease.addEventListener('click', event => {
                setTimeout(() => {
                  if (typeof HsCartDrawer !== 'undefined') {
                    HsCartDrawer.getSlideCart();
                  }
                }, 500);
              })
            }

            if ($giftBoxQuantityIncrease) {
              $giftBoxQuantityIncrease.addEventListener('click', event => {
                setTimeout(() => {
                  if (typeof HsCartDrawer !== 'undefined') {
                    HsCartDrawer.getSlideCart();
                  }
                }, 500);
              })
            }

            if ($giftBoxQuantityInput) {
              $giftBoxQuantityInput.addEventListener('change', event => {
                setTimeout(() => {
                  if (typeof HsCartDrawer !== 'undefined') {
                    HsCartDrawer.getSlideCart();
                  }
                }, 500);
              })
            }
          }

          let giftBoxKey = matchingGiftBox.key;
          let existingMessage = matchingGiftBox.properties['Gift Message'];
          if ($matchingGiftBox) {
            let $giftMessage = $matchingGiftBox.querySelector('.hs-content-propertie:last-child');
            if ($giftMessage) {
              $giftMessage.insertAdjacentHTML('afterend', `<div class="giftboxEditRemoveWrapper" style="display: flex; align-items: center;"><button class="giftboxInputWrapper__button giftboxInputWrapper__editButton" type="button" data-key="${matchingGiftBox.key}">EDIT MESSAGE</button><button class="giftboxInputWrapper__button giftboxInputWrapper__removeButton" type="button" data-key="${matchingGiftBox.key}">REMOVE GIFT BOX</button></div>`)
            }

            let textAreaContent = `
              <div class="giftboxInputWrapper giftboxInputWrapper--message" style="width: 100%; align-items: center; justify-content: space-between;">
                    <textarea class="giftboxInputWrapper__textarea" placeholder="Enter message here. One shipping address per order." data-new="false" data-key="${matchingGiftBox.key}">${existingMessage}</textarea>
                   </div>`;
            if ($giftMessage) {
              $giftMessage.insertAdjacentHTML('afterend', textAreaContent);
            }
          }

          const $quantityDecrease = $product.querySelector('.hs-cart-plus-minus .hs-dec');
          const $quantityInput = $product.querySelector('.hs-cart-plus-minus input');
          const $quantityIncrease = $product.querySelector('.hs-cart-plus-minus .hs-inc');
          if ($quantityInput) {
            $quantityInput.addEventListener('change', event => {
              if (Number($quantityInput.value) <= 0) {
                setTimeout(() => {
                  updateCartQuantityByItemKey(giftBoxKey, 0);
                }, 500);
              } else {
                setTimeout(() => {
                  if (typeof HsCartDrawer !== 'undefined') {
                    HsCartDrawer.getSlideCart();
                  }
                }, 500);
              }
            })

            if ($quantityDecrease) {
              $quantityDecrease.addEventListener('click', event => {

                if (Number($quantityInput.value) === 0) {
                  setTimeout(() => {
                    updateCartQuantityByItemKey(giftBoxKey, 0);
                  }, 500);

                }
                else {
                  setTimeout(() => {
                    if (typeof HsCartDrawer !== 'undefined') {
                      HsCartDrawer.getSlideCart();
                    }
                  }, 500);
                }
              })
            }
          }


          if ($quantityIncrease) {
            $quantityIncrease.addEventListener('click', event => {
              setTimeout(() => {
                if (typeof HsCartDrawer !== 'undefined') {
                  HsCartDrawer.getSlideCart();
                }
              }, 500);

            })
          }


        }

        let $textareaWrapper;
        if ($matchingGiftBox) {
          $textareaWrapper = $matchingGiftBox.querySelector('.giftboxInputWrapper--message');
        }
        else {
          $textareaWrapper = $product.querySelector('.giftboxInputWrapper--message');
        }


        const $giftboxMessage = $product.querySelector('.giftboxInputWrapper__giftMessage');

        const $label = $product.querySelector('.giftboxInputWrapper label');

        const $checkbox = $product.querySelector('.giftboxInputWrapper__checkbox');
        if ($checkbox) {
          // Show or hide the message box
          $checkbox.addEventListener('change', event => {
            if ($checkbox.checked) {
              $textareaWrapper.style.display = "block";
            } else {
              $textareaWrapper.style.display = "none";
            }
          })

          $label.addEventListener('click', event => {
            if ($checkbox.checked) {
              $checkbox.checked = false;
              $textareaWrapper.style.display = "none";
            }
            else {
              $checkbox.checked = true;
              $textareaWrapper.style.display = "block";
            }
          })
        }

        let $textarea;
        let $saveMessage;
        let editMode = false;

        if ($matchingGiftBox) {
          // Creates or edits the gift box message
          $textarea = $matchingGiftBox.querySelector('.giftboxInputWrapper__textarea');
          $saveMessage = $matchingGiftBox.querySelector('.giftboxInputWrapper__saveMessage');

          // Reveals the textarea to edit the message
          const $editButton = $matchingGiftBox.querySelector('.giftboxInputWrapper__editButton');
          if ($editButton && $textarea) {

            $textarea.addEventListener('blur', event => {
              if ($textarea.dataset.saving !== "true") {
                $textarea.dataset.saving = "true";
                editGiftBoxMessageHandler(true, $textareaWrapper, $textarea, $editButton, matchingGiftBox, productTitle, $giftboxMessage, $saveMessage);
              }
            });

            $textarea.addEventListener('keypress', event => {

              if (event.keyCode === 13) {
                if ($textarea.dataset.saving !== "true") {
                  $textarea.dataset.saving = "true";
                  editGiftBoxMessageHandler(true, $textareaWrapper, $textarea, $editButton, matchingGiftBox, productTitle, $giftboxMessage, $saveMessage);
                }
              }
            });


            $editButton.addEventListener('click', event => {

              if (editMode === true) {
                $textarea.dataset.saving = "true";
              }

              editGiftBoxMessageHandler(editMode, $textareaWrapper, $textarea, $editButton, matchingGiftBox, productTitle, $giftboxMessage, $saveMessage);

              if (editMode === false) {
                editMode = true;
              }
              else {
                editMode = false;
              }

            });
          }



          // Removes the gift box
          const $removeButton = $matchingGiftBox.querySelector('.giftboxInputWrapper__removeButton');
          if ($removeButton) {
            $removeButton.addEventListener('click', event => {
              updateCartQuantityByItemKey($removeButton.dataset.key, 0);
            });
          }
        }
        else {
          // Creates or edits the gift box message
          $textarea = $product.querySelector('.giftboxInputWrapper__textarea');
          $saveMessage = $product.querySelector('.giftboxInputWrapper__saveMessage');

          // This is a first-time message
          if ($textarea && $saveMessage && $textarea.dataset.new === "true") {

            async function addGiftBox(product, giftBoxID, productTitle, message, $saveMessage, $textarea) {
              // make sure product is in stock before continuing
              const inStock = await checkProductStock(product.handle, product.variant_id);
              if (!inStock) {
                $saveMessage.innerHTML = `
                  <p class="giftboxInputWrapper__message">
                    Sorry, this product is out of stock.
                  </p>
                `;
                return;
              }

              // add temp styles to hide empty cart message
              const style = document.createElement('style');
              style.id = 'tempStyle';
              style.innerHTML = `
                .hs-empty-cart {
                  display: none;
                }
              `;
              document.head.appendChild(style);

              // Remove product from the cart
              let changeFormData = {
                id: product.key,
                quantity: 0,
              };

              fetch('/cart/change.js', {
                body: JSON.stringify(changeFormData),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
              })
                .then(function (response) {
                  return response.json();
                })
                // Product has been removed from the cart
                .then(function (json) {
                  // Now we add the gift box to the cart
                  let formData = {
                    'items': [{
                      'id': giftBoxID,
                      'quantity': 1,
                      'properties': {
                        'For': productTitle,
                        'Gift Message': message,
                      }
                    }]
                  };

                  fetch('/cart/add.js', {
                    body: JSON.stringify(formData),
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                  })
                    .then(function (response) {
                      const spinnerWrapper = document.createElement('div');
                      spinnerWrapper.classList.add('spinnerWrapper');

                      const spinner = document.createElement('div');
                      spinner.classList.add('spinner');

                      spinnerWrapper.appendChild(spinner);

                      // insert spinner before empty cart message
                      const emptyCart = document.querySelector('.hs-empty-cart');
                      if (emptyCart) {
                        emptyCart.parentNode.insertBefore(spinnerWrapper, emptyCart);
                      }

                      return response.json();
                    })
                    // The gift box has now been added to the cart
                    .then(function (json) {
                      // Hide save button
                      $saveMessage.style.display = "none";
                      // Hide textarea
                      $textarea.style.display = "none";

                      // Now we re-add the product after the gift box
                      let formData = {
                        'items': [{
                          'id': product.variant_id,
                          'quantity': product.quantity,
                        }]
                      };

                      fetch('/cart/add.js', {
                        body: JSON.stringify(formData),
                        credentials: 'same-origin',
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'XMLHttpRequest'
                        },
                      }).then(function (response) {
                        return response.json();
                      }).then(function (json) {
                        $textarea.dataset.saving = "false";
                        setTimeout(() => {
                          if (typeof window.HSSLIDECART !== 'undefined' && typeof HsCartDrawer !== 'undefined') {
                            HsCartDrawer.getSlideCart();
                          }
                        }, 500);
                      }).catch(function (err) {
                        console.error(err)
                      })
                        .finally(function () {
                          const tempStyle = document.querySelector('#tempStyle');
                          if (tempStyle) {
                            setTimeout(() => {
                              document.head.removeChild(tempStyle);
                            }, 5000);
                          }
                        });
                    });
                });
            }

            $textarea.addEventListener('blur', event => {
              if ($checkbox.checked && $textarea.dataset.saving !== "true") {
                console.log("============ BLUR CALLED ============");
                $textarea.dataset.saving = "true";
                addGiftBox(product, giftBoxID, productTitle, $textarea.value, $saveMessage, $textarea);
              }
            });

            $textarea.addEventListener('keypress', event => {
              // Enter key is pressed
              if (event.keyCode === 13 && $checkbox.checked && $textarea.dataset.saving !== "true") {
                console.log("============ KEYPRESS CALLED ============");
                $textarea.dataset.saving = "true";
                addGiftBox(product, giftBoxID, productTitle, $textarea.value, $saveMessage, $textarea);
              }
            });

            $saveMessage.addEventListener('click', event => {
              if ($checkbox.checked && $textarea.dataset.saving !== "true") {
                console.log("============ CLICK SAVE CALLED ============");
                $textarea.dataset.saving = "true";
                addGiftBox(product, giftBoxID, productTitle, $textarea.value, $saveMessage, $textarea);
              }
            });





          }
        }
      }
    }).catch(function (err) {

      console.error(err)
    });
  }, '.hs-item-cart-content');

  function editGiftBoxMessageHandler(editMode, $textareaWrapper, $textarea, $editButton, matchingGiftBox, productTitle, $giftboxMessage, $saveMessage) {
    // Clicked edit
    if (editMode === false) {
      $textareaWrapper.style.display = "block";
      $textarea.style.display = "block";
      $editButton.textContent = "SAVE MESSAGE";
    }
    // Clicked save
    else {
      $textareaWrapper.style.display = "none";
      $editButton.textContent = "EDIT MESSAGE";


      // Editing a message
      let changeFormData = {
        id: $textarea.dataset.key,
        quantity: matchingGiftBox.quantity,
        properties: {
          'For': productTitle,
          'Gift Message': $textarea.value,
        },
      };

      fetch('/cart/change.js', {
        body: JSON.stringify(changeFormData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },

      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        $textarea.dataset.saving = "false";

        if (typeof window.HSSLIDECART !== 'undefined' && typeof HsCartDrawer !== 'undefined') {
          HsCartDrawer.getSlideCart();
        }
        // Change gift message text in cart drawer
        $giftboxMessage.textContent = `Gift Message: ${$textarea.value}`;
        // Hide save button
        $saveMessage.style.display = "none";
        // Hide textarea
        $textarea.style.display = "none";
      }).catch(function (err) {

        console.error(err)
      });
    }
  }


  function updateCartQuantityByItemKey(key, quantity, refresh = true) {
    let changeFormData = {
      id: key,
      quantity: quantity,
    };

    fetch('/cart/change.js', {
      body: JSON.stringify(changeFormData),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

    }).then(function (response) {
      return response.json();
    }).then(function (json) {

      if (refresh === true) {
        if (typeof window.HSSLIDECART !== 'undefined' && typeof HsCartDrawer !== 'undefined') {
          HsCartDrawer.getSlideCart();
        }
      }

    }).catch(function (err) {

      console.error(err)
    });
  }


});
